import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../../../../packages/common/src/app/reducerPaths";
import { baseQueryWithAuth } from "../../../../../packages/common/src/toolkit/methods/baseQueryWithAuth";
import { VITE_NODE_SERVER_BASE_URL } from "@common/utils/constants/urls/baseUrls";

export const paymentsApi = createApi({
  reducerPath: reducerPaths.paymentsApi,
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    downloadBOS: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/seller/download-bos-seller/${Vehicle_Id}`,
          method: "GET",
          meta: {
            isBinary: true
          }
        }
      },
      transformResponse: (response) => {
        // This receives the raw PDF string from the baseQuery's 'text' handler
        if (typeof response === 'string' && response.startsWith('%PDF')) {
          // Convert the string into a Blob
          return new Blob([response], { type: 'application/pdf' });
        }
        // Fallback or error handling
        return response;
      },
    }),
    downloadBOSDealer: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          url: `/download-bos/${Vehicle_Id}`,
          method: "GET",
          meta: {
            isBinary: true
          }
        }
      },
      transformResponse: (response) => {
        // This receives the raw PDF string from the baseQuery's 'text' handler
        if (typeof response === 'string' && response.startsWith('%PDF')) {
          // Convert the string into a Blob
          return new Blob([response], { type: 'application/pdf' });
        }
        // Fallback or error handling
        return response;
      },
    }),
    calculateBuyerPayment: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `/buyer/calculateBuyerPayment`,
          method: "POST",
          body: payload
        }
      }
    }),
    calculateBuyerPaymentCrypto: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `${VITE_NODE_SERVER_BASE_URL}/buyer/calculateCarCryptoPaymentBreakdown`,
          method: "POST",
          body: payload
        }
      }
    }),
    fetchPaymentDetails: builder.query({
      query: ({ params }) => {
        return {
          url: `${VITE_NODE_SERVER_BASE_URL}/buyer/carPaymentDetails`,
          method: "GET",
          params
        }
      }
    }),
    calculateGasFee: builder.query({
      query: ({ params }) => {
        return {
          url: `${VITE_NODE_SERVER_BASE_URL}/calculateGasFee`,
          method: "GET",
          params
        }
      }
    })
  }),
});

export const {
  useLazyDownloadBOSQuery,
  useLazyFetchPaymentDetailsQuery,
  useLazyDownloadBOSDealerQuery,
  useLazyCalculateGasFeeQuery,
  useCalculateBuyerPaymentMutation,
  useCalculateBuyerPaymentCryptoMutation
} = paymentsApi;